export const EVENTS = {
  userSessionTimeOut: 'userSessionTimeOut'
}
